import CryptoJS from 'crypto-js';

export default class Encryptor {
    constructor() {
        if (!process.env.REACT_APP_SECRET_KEY) throw new Error('Secret key is required');
        this.secretKey = process.env.REACT_APP_SECRET_KEY;
    }

    /**
     * Codifica Base64 a una versión URL-safe
     * @param {string} base64Str
     * @returns {string}
     */
    toUrlSafeBase64(base64Str) {
        return base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    /**
     * Convierte una cadena URL-safe Base64 a Base64 estándar
     * @param {string} urlSafeStr
     * @returns {string}
     */
    fromUrlSafeBase64(urlSafeStr) {
        let base64 = urlSafeStr.replace(/-/g, '+').replace(/_/g, '/');
        while (base64.length % 4 !== 0) {
            base64 += '=';
        }
        return base64;
    }

    /**
     * Encripta un valor (número o texto) en formato URL-safe
     * @param {string | number} value
     * @returns {string} Encrypted string (URL-safe Base64)
     */
    encrypt(value) {
        const encrypted = CryptoJS.AES.encrypt(value.toString(), this.secretKey).toString();
        return this.toUrlSafeBase64(encrypted);
    }

    /**
     * Desencripta un valor cifrado en formato URL-safe
     * @param {string} encryptedValue
     * @returns {string} Plain text
     */
    decrypt(encryptedValue) {
        const base64 = this.fromUrlSafeBase64(encryptedValue);
        const bytes = CryptoJS.AES.decrypt(base64, this.secretKey);
        return bytes.toString(CryptoJS.enc.Utf8);
    }
}
